import OptimizationStore from "../../../store/OptimizationStore"
import * as keys from "./keys"
import Validator from "./validator"
import calculateRiderPremium from "utils/calculateRiderPremium"
import calculateProductPremiumRelatedValues from "utils/calculateProductPremiumRelatedValues"
import isObjectEmpty from "utils/isObjectEmpty"
import ProductConstants from 'constants/ProductConstants';
import * as Constants from "constants/Constants"

class Utils {

  getPTList = (age, isAdd) => {
    let list = []

    if (Number(age) > 60) {
      list = []
    } else if (Number(age) >= 56 && Number(age) <= 60) {
      list = [
        { label: '25', id: '25' },
      ]
    } else if (Number(age) >= 51 && Number(age) <= 55) {
      list = [
        { label: '25', id: '25' },
        { label: '30', id: '30' },
      ]
    } else if (Number(age) >= 46 && Number(age) <= 50) {
      list = [
        { label: '25', id: '25' },
        { label: '30', id: '30' },
        { label: '35', id: '35' },
      ]
    } else if (Number(age) <= 45) {
      list = [
        { label: '25', id: '25' },
        { label: '30', id: '30' },
        { label: '35', id: '35' },
        { label: '40', id: '40' },
      ]
    }
    if (!isAdd) {
      list.unshift({ label: '20', id: '20' })
    }
    return list;
  }

  getPlanOptionList = (pt, ppt) => {
    let list = [{ id: 1, label: 'Regular income' }]
    let eligiblePt = [25, 30, 35, 40]
    let eligiblePpt = [8, 10, 12]
    if (eligiblePt.includes(pt) && eligiblePpt.includes(ppt)) {
      list.push({ id: 2, label: 'Regular income advantage' })
    }
    return list;
  }

  PredefinedOptList(firstId, optionId, endId) {
    let startOptId = optionId
    let list = []
    for (let i = firstId; i <= endId; i++) {
      list.push({
        id: startOptId,
        label: i,
      });
      startOptId += 1
    }
    return list
  }

  getIncomeBenefitOptions = (productName, ppt) => {
    let payoutList = []
    switch (productName) {
      case "Premier Guaranteed Income (Short Term Income)":
        payoutList = [{ id: ppt, label: ppt }]
        break

      case "Premier Guaranteed Income (Long Term Income)":
        payoutList.push({ id: 15, label: 15 })
        payoutList.push({ id: 20, label: 20 })
        payoutList.push({ id: 25, label: 25 })

        if (ppt === 5 && ppt === 8 && ppt === 10) {
          payoutList.push({ id: 30, label: 30 })
        }

        break

      case "Premier Guaranteed Income (Lump sum)":
        break

      case "Premier Guaranteed Income (Retirement Income)":
        payoutList.push({ id: 20, label: 20 })
        break

      default:
        break
    }
    return payoutList
  }

  getTotalPrice = (biResponse, biRequest) => {
    try {
      return Number(biResponse?.PREM_DISP)
    } catch (e) {
      return 0
    }
  }



  getRiderTax = (data) => {
    let totalRider = 0
    data?.parsedResponse?.inputValidationStatus?.map((item) => {
      totalRider += Number(item.Tax)
    })
    return totalRider
  }

  updateBi = (key, value, productId, formRef, productData) => {
    let selectedRiskType = productData?.data?.selectedRisk;
    let selectedRiskProductObject = productData?.data?.BI.filter((item) => item.risk == selectedRiskType)[0];
    let biData = OptimizationStore.fetchBiRequest(productId, selectedRiskProductObject.family_product_id);
    let biRequest = biData.data.bi_request
    switch (key) {
      case keys.PPT:
        biRequest[keys.PPT] = value.ppt
        biRequest[keys.PT] = value.pt
        break

      case keys.PT:
        biRequest[keys.PT] = value.pt
        biRequest[keys.PPT] = value.ppt
        break

      case keys.INCOME_START_OPTION:
        // biRequest[keys.PT] = "0"
        biRequest[keys.INCOME_START_OPTION] = value
        break

      case keys.INCOME_DURATION:
        biRequest[keys.PT] = value.pt
        biRequest[keys.INCOME_DURATION] = value.incomeDuration
        break

      case keys.PREMIUM_OFFSET_OPTION:
        biRequest[keys.PREMIUM_OFFSET_OPTION] = value
        break

      case keys.PREMIUM_OFFSET_OPTION_INCOME_START_YEAR:
        biRequest[keys.PREMIUM_OFFSET_OPTION_INCOME_START_YEAR] = value
        break

      case keys.LUMPSUM_BENEFIT:
        biRequest[keys.LUMPSUM_BENEFIT] = value
        break

      case keys.FREQUENCY:
        biRequest[keys.FREQUENCY] = value.frequency
        break

      case keys.PREMIUM:
        biRequest[keys.PREMIUM] = value
        break

      case keys.INCOME_OPTION:
        biRequest[keys.INCOME_OPTION] = value?.income_option
        biRequest[keys.INCREASING] = value?.increasing
        break

      case keys.CASHBACK:
        biRequest[keys.CASHBACK] = value
        break

      case keys.INCREASING:
        biRequest[keys.INCREASING] = value
        break

      case keys.CASHBACK_PERCENT_ANNUALISED_PREMIUM:
        biRequest[keys.CASHBACK_PERCENT_ANNUALISED_PREMIUM] = value
        break

      case keys.TIMING_OF_INCOME_STAR_TYEAR:
        biRequest[keys.TIMING_OF_INCOME_STAR_TYEAR] = value
        break

      case keys.INCOME_BENEFIT_PAYOUT_START_YEAR:
        biRequest[keys.INCOME_BENEFIT_PAYOUT_START_YEAR] = value
        break
      case keys.PR_SAMF:
        biRequest[keys.PR_SAMF] = value
        break

      case keys.WOP_RIDER:
        biRequest[keys.WOP_RIDER] = value
        break

      case keys.ADB_RIDER:
        if (value) {
          biRequest[keys.ADB_RIDER] = value
        } else {
          biRequest[keys.ADB_RIDER] = ""
        }
        break

      case keys.ATPD_RIDER:
        if (value) {
          biRequest[keys.ATPD_RIDER] = value
        } else {
          biRequest[keys.ATPD_RIDER] = ""
        }
        break

      case keys.Critical_ILLNESS_RIDER:
        if (value) {
          biRequest[keys.Critical_ILLNESS_RIDER] = value
        } else {
          biRequest[keys.Critical_ILLNESS_RIDER] = ""
        }
        break

      case keys.INCOME_BENEFIT_RIDER:
        if (value) {
          biRequest[keys.INCOME_BENEFIT_RIDER] = value
        } else {
          biRequest[keys.INCOME_BENEFIT_RIDER] = ""
        }
        break

      case keys.PWB_RIDER:
        if (value) {
          biRequest[keys.PWB_RIDER] = "1"
          biRequest.PWB = "" + value
        } else {
          biRequest[keys.PWB_RIDER] = ""
        }
        break

      case keys.HOSPITALITY_CASH_BENEFIT_RIDER:
        if (value) {
          biRequest[keys.HOSPITALITY_CASH_BENEFIT_RIDER] = value
        } else {
          biRequest[keys.HOSPITALITY_CASH_BENEFIT_RIDER] = ""
        }
        break

      case keys.FAMILY_BENEFIT_INCOME_OPTION:
        biRequest[keys.FAMILY_BENEFIT_INCOME_OPTION] = value
        break

      case keys.INCOME_BENEFIT_PAYOUT_FREQUENCY:
        biRequest[keys.INCOME_BENEFIT_PAYOUT_FREQUENCY] = value
        break

      case keys.INCOME_BENEFIT_PAYOUT_TYPE:
        biRequest[keys.INCOME_BENEFIT_PAYOUT_TYPE] = value
        break

      case keys.IS_EXISTING_CUSTOMER:
        biRequest[keys.IS_EXISTING_CUSTOMER] = value
        break

      case keys.IS_ECA_MANDATE:
        biRequest[keys.IS_ECA_MANDATE] = value
        break

      case keys.INCOME_BENEFIT_DURATION:
        biRequest[keys.INCOME_BENEFIT_DURATION] = value
        break

      case keys.ACCRUALOFSURVIVALBENEFIT_1:
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_1] = value.asb1;
        biRequest[keys.ASB_STARTPOLICYYEAR_1] = value.asbStartYear1 ? value.asbStartYear1 : "";
        biRequest[keys.ASB_ENDPOLICYYEAR_1] = value.asbEndYear1 ? value.asbEndYear1 : "";
        break;

      case keys.ASB_STARTPOLICYYEAR_1:
        biRequest[keys.ASB_STARTPOLICYYEAR_1] = value.asbStart1 ? value.asbStart1 : ""
        biRequest[keys.ASB_ENDPOLICYYEAR_1] = value.asbEnd1 ? value.asbEnd1 : "";
        break;

      case keys.ASB_ENDPOLICYYEAR_1:
        biRequest[keys.ASB_ENDPOLICYYEAR_1] = value.asbEnd1 ? value.asbEnd1 : "";
        break;

      case keys.ASB_WITHDRAWALPERCENTAGE_1:
        biRequest[keys.ASB_WITHDRAWALPERCENTAGE_1] = value ? value : ""
        break

      case keys.IS_INCOME_BENEFIT_ADVANCE:
        biRequest[keys.IS_INCOME_BENEFIT_ADVANCE] = value ? value : ""
        break

      case keys.DEATH_BENEFIT_OPTION:
        biRequest[keys.DEATH_BENEFIT_OPTION] = value ? value : ""
        break

      case keys.PLAN_OPTION:
        biRequest[keys.PLAN_OPTION] = value ? value : ""
        break

      case keys.SUM_ASSUREDDON_MATURITY:
        biRequest[keys.SUM_ASSUREDDON_MATURITY] = value ? value : ""
        break

      case keys.ADVANTAGE_BENEFIT_PERCENTAGE:
        biRequest[keys.ADVANTAGE_BENEFIT_PERCENTAGE] = value ? value : ""
        break

      case keys.INCOME_BENEFIT_PAYOUT_FREQUENCY:
        biRequest[keys.INCOME_BENEFIT_PAYOUT_FREQUENCY] = value ? value : ""
        break


    }
    OptimizationStore.updateBiRequest(productId, biRequest, productData.data.family_product_id, key, value)
    // let errorMessage = Validator.valid(formRef, biData)

    // if (errorMessage.length > 0) {
    //   return
    // }

    // OptimizationStore.updateStoreRequestData(productId, biRequest, key, value)
  }

  getAdbList = () => {
    let list = []
    for (let index = 0; index <= 100; index = index + 5) {
      if (index != 100) {
        list.push({
          id: index == 0 ? 1 : index,
          label: (index == 0 ? 1 : index) + " L",
        })
      } else {
        list.push({
          id: index,
          label: 1 + " Cr.",
        })
      }
    }
    return list
  }

  getAtpdList = () => {
    return this.benefitAmountList(100000, 1000000)
  }

  getCriticalIllnessList = () => {
    return this.benefitAmountList(100000, 500000)
  }

  getIncomeBenefit = () => {
    let initialValue = 75000
    let values = []

    for (let i = 1; i <= 8; i++) {
      values.push({ id: i * initialValue, label: i * initialValue })
    }

    return values
  }

  benefitAmountList = (min, max) => {
    let values = []

    max = Math.round(max / 100000)
    for (let i = 1; i <= max; i++) {
      values.push({ id: i, label: i + " L" })
    }
    return values
  }

  newPolicyTimeLineData(element, inputString, index, productName) {

    const { MODAL_PREM, INCOME_BENEFIT_FINAL, DB_G, INCOME_BENEFIT_PAYOUT_LARGE, MB_G, ANN_PREM_YEARLY } = element

    let incomeOption = inputString.find(item => item.Key === '@DISPLAY_PR_OPTION_2').Value

    const flexiblIncomeArray = [
      ProductConstants.POS_NEW_GUARANTEED_INCOME_STAR_NON_PAR,
      ProductConstants.POS_NEW_GUARANTEED_INCOME_STAR_NON_PAR_CASHBACK_GUARANTEED,
      ProductConstants.POS_NEW_GUARANTEED_INCOME_STAR_NON_PAR_BETTER_INNINGS,
      ProductConstants.NEW_GUARANTEED_INCOME_STAR_NON_PAR_CASHBACK_GUARANTEED,
      ProductConstants.GUARANTEED_FLEX_STAR,
      ProductConstants.NEW_GUARANTEED_INCOME_STAR_NON_PAR_BETTER_INNINGS,
      ProductConstants.NEW_GUARANTEED_INCOME_STAR_NON_PAR_CASHBACK_GUARANTEED_FIB,
      ProductConstants.NEW_GUARANTEED_INCOME_STAR_NON_PAR_BETTER_INNINGS_FIB,
      ProductConstants.NEW_GUARANTEED_INCOME_STAR_NON_PAR_FIB
    ]

    const largeIncomeBenefitArray = [
      ProductConstants.GUARANTEED_FLEX_STAR,
      ProductConstants.NEW_GUARANTEED_INCOME_STAR_NON_PAR_MILESTONES_GUARANTEED,
      ProductConstants.NEW_GUARANTEED_INCOME_STAR_NON_PAR_FIB
    ]


    if (flexiblIncomeArray.includes(productName) && (incomeOption === 'Flexible Income')) {

      let data = {
        youPay: Math.round(ANN_PREM_YEARLY),
        youGet: Math.round(INCOME_BENEFIT_FINAL) + Math.round(MB_G),
        lifeCover: Math.round(DB_G)
      }
      return data
    }

    if (largeIncomeBenefitArray.includes(productName) && (incomeOption === 'Large income Benefit')) {
      let data = {
        youPay: Math.round(ANN_PREM_YEARLY),
        youGet: Math.round(INCOME_BENEFIT_PAYOUT_LARGE) + Math.round(MB_G),
        lifeCover: Math.round(DB_G)
      }

      return data
    }
  }

  fetchIncomeStartOptionValue(incomeStartOption) {
    switch (incomeStartOption?.toString()) {

      case '7':
        return { label: '2', id: '7' }

      case '8':
        return { label: '5', id: '8' }

      case '9':
        return { label: '6', id: '9' }

      case '10':
        return { label: '7', id: '10' }

      case '11':
        return { label: '8', id: '11' }

      case '12':
        return { label: '9', id: '12' }

      case '13':
        return { label: '10', id: '13' }

      case '14':
        return { label: '11', id: '14' }

      case '15':
        return { label: '12', id: '15' }

      case '16':
        return { label: '13', id: '16' }

      case '17':
        return { label: '14', id: '17' }

      case '18':
        return { label: '15', id: '18' }

      case '19':
        return { label: '18', id: '19' }

      case '20':
        return { label: '20', id: '20' }

      case '21':
        return { label: '22', id: '21' }

      default:
        return { label: '', id: '' }

    }
  }

  fetchIncomeDuration(incomeDuration) {
    switch (incomeDuration?.toString()) {
      case '3':
        return 10

      case '4':
        return 15

      case '5':
        return 20

      case '6':
        return 25

      case '7':
        return 30

      case '8':
        return 35

      default:
        return ""
    }
  }

  IncomeBenefitPayoutStartYear(incomeStartYearOption) {
    switch (incomeStartYearOption?.toString()) {
      case '21':
        return { label: 1, id: '21' };
      case '22':
        return { label: 2, id: '22' };
      case '23':
        return { label: 3, id: '23' };
      case '24':
        return { label: 4, id: '24' };
      case '25':
        return { label: 5, id: '25' };
      case '26':
        return { label: 6, id: '26' };
      case '27':
        return { label: 7, id: '27' };
      case '28':
        return { label: 8, id: '28' };
      case '29':
        return { label: 9, id: '29' };
      case '30':
        return { label: 10, id: '30' };
      case '31':
        return { label: 11, id: '31' };
      case '32':
        return { label: 12, id: '32' };
      case '33':
        return { label: 13, id: '33' };
      case '34':
        return { label: 14, id: '34' };
      default:
        return { label: '', id: '' };
    }
  }

  PremiumOffsetOptionIncomeStartYear(option) {
    switch (option?.toString()) {
      case '51':
        return 4;
      case '52':
        return 5;
      case '53':
        return 6;
      case '54':
        return 7;
      case '55':
        return 8;
      case '56':
        return 9;

    }
  }
  generatePredefinedOptListForAIS(firstId, optionId) {
    let startOptId = optionId
    let list = []
    for (let i = firstId; i <= 40; i++) {
      list.push({
        id: startOptId,
        label: i,
      });
      startOptId += 1
    }
    return list
  }

  // generatePredefinedOptListForWithDrawalParcentageAIS(firstId, optionId) {
  //   let startOptId = optionId
  //   let list = []
  //   for (let i = firstId; i <= 10; i++) {
  //     list.push({
  //       id: startOptId,
  //       label: i + '%',
  //     });
  //     startOptId += 1
  //   }
  //   return list
  // }

  generatePredefinedOptListForWithDrawalParcentageAIS(firstId, optionId) {
    let list = []
    for (let i = firstId; i <= 10; i++) {
      list.push({
        id: optionId + i,
        label: (i * 10).toFixed(2) + '%',
      });
    }
    return list
  }

  setHideAndResetValue(formRef, key, value, noOptParamValue) {
    formRef.$(key).set("extra", { ...formRef.$(key).extra, hide: value });
    if (noOptParamValue) {
      formRef.$(key).set("value", { label: "No", id: noOptParamValue });
    } else {
      formRef.$(key).set("value", "");
    }
  }

  handleASBstartPolicyOneConditions(formRef, productName, PT_value, liAge) {

    if (Number(formRef.$("accrual-of-survival-benefit").value.id) == 13) {
      let asbStartYearOneList = this.fetchASBstartPolicyOne(
        formRef.$("plan-option").value.id,
        PT_value,
        formRef.$("PPT").value.id,
        formRef.$("asb-start-age-(1st-opt-in)").extra.preDefinedOptList,
        liAge
      );

      console.log("asbStartYearOneList ", asbStartYearOneList)

      formRef.$("asb-start-age-(1st-opt-in)").set("extra", {
        ...formRef.$("asb-start-age-(1st-opt-in)").extra,
        optionList: asbStartYearOneList,
      });
      formRef.$("asb-start-age-(1st-opt-in)").set("value", asbStartYearOneList[0]);

      let asbEndYearOneList = this.fetchASBendPolicyOne(
        formRef.$("asb-start-age-(1st-opt-in)").value.id,
        asbStartYearOneList,
        formRef.$("asb-end-age-(1st-opt-in)").extra.preDefinedOptList
      );

      formRef.$("asb-end-age-(1st-opt-in)").set("extra", {
        ...formRef.$("asb-end-age-(1st-opt-in)").extra,
        optionList: asbEndYearOneList,
      });

      let selectedAsbEndYearOne = asbEndYearOneList.some(
        (item) =>
          item.id === formRef.$("asb-end-age-(1st-opt-in)").value.id
      );
      if (!selectedAsbEndYearOne) {
        formRef
          .$("asb-end-age-(1st-opt-in)")
          .set("value", asbEndYearOneList[asbEndYearOneList.length - 1]);
      }
    }
  }


  // handled ASB 1
  handleAsbCondition(formRef, asb1Value) {

    if (Number(asb1Value) === 14) {
      this.setHideAndResetValue(formRef, "asb-start-age-(1st-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(1st-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-1", true);
    } else {
      this.setHideAndResetValue(formRef, "asb-start-age-(1st-opt-in)", false);
      this.setHideAndResetValue(formRef, "asb-end-age-(1st-opt-in)", false);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-1", false);
    }
  }

  // handled ASB start year 1
  fetchASBstartPolicyOne(planOption, pt, ppt, preDefinedOptList, liAge) {
    let startYearList = [];
    // let value = Number(pt) === 40 ? Number(pt) - 1 : Number(pt);
    let value = Number(pt) - 1;
    let startPoint = 1;
    // if (Number(planOption) === 2) startPoint = Number(Number(ppt) + 2);
    for (let i = startPoint; i <= 40; i++) {
      let optData = preDefinedOptList.find((item) => item.label === i)
      startYearList.push(optData);
    }
    return startYearList;
  }

  // handled ASB end year 1
  fetchASBendPolicyOne(startYear1, asbStartYearOneList, preDefinedOptList) {
    let endYearList = [];
    asbStartYearOneList?.forEach((item) => {
      if (item?.id >= startYear1) {
        let optData = preDefinedOptList.find((opt) => opt?.label === item?.label)
        endYearList.push(optData);
      }
    });
    return endYearList;
  }

}

export default new Utils()
